import React from "react";

const CarouselPlaceholder = (): JSX.Element => (
  <div id="carousel-placeholder">
    <style jsx>{`
      #carousel-placeholder {
        height: 318px;
      }
      @media screen and (min-width: 1023px) {
        #carousel-placeholder {
          height: 446px;
        }
      }
    `}</style>
  </div>
);

export default CarouselPlaceholder;
